var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getMessage from 'src/background/utils/i18n.utils';
import { setErrorMessage } from '@popup/multichain/actions/message.actions';
import { navigateToWithParams } from '@popup/multichain/actions/navigation.actions';
import { setTitleContainerProperties } from '@popup/multichain/actions/title-container.actions';
import { AccountCreationType, AccountCreationUtils, } from '@popup/steem/utils/account-creation.utils';
import AccountUtils from '@popup/steem/utils/account.utils';
import CurrencyUtils from '@popup/steem/utils/currency.utils';
import SteemUtils from '@popup/steem/utils/steem.utils';
import { Screen } from '@reference-data/screen.enum';
import { Asset as CommonAsset } from '@steempro/steem-keychain-commons';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import ButtonComponent from 'src/common-ui/button/button.component';
import { ComplexeCustomSelect, } from 'src/common-ui/custom-select/custom-select.component';
import { SVGIcons } from 'src/common-ui/icons.enum';
import { InputType } from 'src/common-ui/input/input-type.enum';
import InputComponent from 'src/common-ui/input/input.component';
const CreateAccountStepOne = ({ activeAccount, accounts, currencyLabels, setTitleContainerProperties, navigateToWithParams, }) => {
    const [accountOptions, setAccountOptions] = useState();
    const [selectedAccount, setSelectedAccount] = useState();
    const [accountName, setAccountName] = useState('');
    const [price, setPrice] = useState(3);
    const [creationType, setCreationType] = useState();
    useEffect(() => {
        setTitleContainerProperties({
            title: 'popup_html_create_account',
            isBackButtonEnabled: true,
        });
        initPrice();
    }, []);
    const initPrice = () => __awaiter(void 0, void 0, void 0, function* () {
        setPrice(yield SteemUtils.getAccountPrice());
    });
    useEffect(() => {
        setSelectedAccount({
            label: `@${activeAccount.name}`,
            value: activeAccount.name,
            canDelete: false,
            img: `https://steemitimages.com/u/${activeAccount.name}/avatar`,
        });
    }, [activeAccount]);
    useEffect(() => {
        initAccountOptions();
    }, [accounts]);
    const initAccountOptions = () => __awaiter(void 0, void 0, void 0, function* () {
        const options = [];
        for (const account of accounts) {
            options.push({
                label: `@${account.name}`,
                value: account.name,
                img: `https://steemitimages.com/u/${account.name}/avatar`,
                canDelete: false,
            });
        }
        setAccountOptions(options);
    });
    useEffect(() => {
        onSelectedAccountChanged(selectedAccount === null || selectedAccount === void 0 ? void 0 : selectedAccount.value);
    }, [selectedAccount]);
    const onSelectedAccountChanged = (username) => __awaiter(void 0, void 0, void 0, function* () {
        if (!selectedAccount) {
            return;
        }
        const account = (yield AccountUtils.getExtendedAccount(username));
        if (account.pending_claimed_accounts > 0) {
            setPrice(0);
            setCreationType(AccountCreationType.USING_TICKET);
        }
        else {
            setPrice(3);
            setCreationType(AccountCreationType.BUYING);
        }
    });
    const validateAccountName = () => __awaiter(void 0, void 0, void 0, function* () {
        if (accountName.length < 3) {
            setErrorMessage('html_popup_create_account_username_too_short');
            return false;
        }
        if (!AccountCreationUtils.validateUsername(accountName)) {
            setErrorMessage('html_popup_create_account_account_name_not_valid');
            return false;
        }
        if (yield AccountCreationUtils.checkAccountNameAvailable(accountName)) {
            return true;
        }
        else {
            setErrorMessage('html_popup_create_account_username_already_used');
            return false;
        }
    });
    const getPriceLabel = () => {
        switch (creationType) {
            case AccountCreationType.BUYING:
                return `${price} ${currencyLabels.steem}`;
            case AccountCreationType.USING_TICKET:
                return getMessage('html_popup_ticket', ['1']);
        }
    };
    const goToNextPage = () => __awaiter(void 0, void 0, void 0, function* () {
        if (yield validateAccountName()) {
            const account = yield AccountUtils.getExtendedAccount(selectedAccount === null || selectedAccount === void 0 ? void 0 : selectedAccount.value);
            const balance = CommonAsset.fromString(account.balance.toString());
            if (creationType === AccountCreationType.USING_TICKET ||
                (creationType === AccountCreationType.BUYING && balance.amount >= 3)) {
                navigateToWithParams(Screen.CREATE_ACCOUNT_PAGE_STEP_TWO, {
                    usedAccount: accounts.find((localAccount) => localAccount.name === (selectedAccount === null || selectedAccount === void 0 ? void 0 : selectedAccount.value)),
                    newUsername: accountName,
                    creationType: creationType,
                    price: price,
                });
            }
            else {
                setErrorMessage('html_popup_account_creation_not_enough_found');
            }
        }
    });
    return (React.createElement("div", { "data-testid": `${Screen.CREATE_ACCOUNT_PAGE_STEP_ONE}-page`, className: "create-account-step-one" },
        selectedAccount && accountOptions && (React.createElement(ComplexeCustomSelect, { selectedItem: selectedAccount, options: accountOptions, setSelectedItem: (item) => setSelectedAccount(item), background: "white" })),
        React.createElement("div", { className: "price-panel" },
            React.createElement("span", { className: "label" }, getMessage('html_popup_price')),
            React.createElement("span", { className: "price" }, getPriceLabel())),
        React.createElement(InputComponent, { onChange: setAccountName, value: accountName, logo: SVGIcons.INPUT_AT, placeholder: "popup_html_username", label: "popup_html_username", type: InputType.TEXT }),
        React.createElement("div", { className: "fill-space" }),
        React.createElement(ButtonComponent, { label: "html_popup_next", onClick: () => goToNextPage() })));
};
const mapStateToProps = (state) => {
    var _a;
    return {
        activeAccount: state.steem.activeAccount,
        accounts: state.steem.accounts,
        currencyLabels: CurrencyUtils.getCurrencyLabels((_a = state.steem.activeRpc) === null || _a === void 0 ? void 0 : _a.testnet),
    };
};
const connector = connect(mapStateToProps, {
    setTitleContainerProperties,
    navigateToWithParams,
});
export const CreateAccountStepOneComponent = connector(CreateAccountStepOne);
